const MINUTE_SECONDS = 60;
const HOUR_SECONDS = 60 * MINUTE_SECONDS;
const DAY_SECONDS = 24 * HOUR_SECONDS;

const SPECS = {
  1: { labelKey: '1m', durationSeconds: MINUTE_SECONDS, intraday: true },
  5: { labelKey: '5m', durationSeconds: 5 * MINUTE_SECONDS, intraday: true },
  15: { labelKey: '15m', durationSeconds: 15 * MINUTE_SECONDS, intraday: true },
  30: { labelKey: '30m', durationSeconds: 30 * MINUTE_SECONDS, intraday: true },
  60: { labelKey: '1H', durationSeconds: HOUR_SECONDS, intraday: true },
  240: { labelKey: '4H', durationSeconds: 4 * HOUR_SECONDS, intraday: true },
  '1D': { labelKey: '1D', durationSeconds: DAY_SECONDS, intraday: false },
  '1W': { labelKey: '1W', durationSeconds: 7 * DAY_SECONDS, intraday: false },
  '1M': { labelKey: '1M', durationSeconds: 30 * DAY_SECONDS, intraday: false },
};

export const CHART_RESOLUTIONS = Object.keys(SPECS);
export const QUICK_RESOLUTIONS = ['1', '5', '15', '60', '1D', '1W', '1M'];
export const DEFAULT_RESOLUTION = '5';
export const STANDARD_BAR_COUNT = 400;

export const isChartResolution = (value) =>
  typeof value === 'string' && Object.prototype.hasOwnProperty.call(SPECS, value);

export const resolutionDurationSeconds = (resolution) => SPECS[resolution].durationSeconds;
export const isIntradayResolution = (resolution) => SPECS[resolution].intraday;
export const resolutionLabelKey = (resolution) => SPECS[resolution].labelKey;
export const initialHistorySeconds = (resolution) =>
  resolutionDurationSeconds(resolution) * STANDARD_BAR_COUNT;

const TIMELINE_TO_RESOLUTION = {
  '1D': '5',
  '1W': '30',
  '1M': '60',
  '3M': '1D',
  YTD: '1D',
  '1Y': '1D',
  MAX: '1W',
};

export const resolutionForTimeline = (timeline) =>
  timeline ? TIMELINE_TO_RESOLUTION[timeline.toUpperCase()] || DEFAULT_RESOLUTION : DEFAULT_RESOLUTION;
